

// export const apiDomain = process.env.REACT_APP_API_BASE_URL 
const hostname = window.location.hostname;
// DEV API
 let apiDomain = process.env.REACT_APP_API_BASE_URL_PRD;
 
 //QAS API
 if (hostname === process.env.REACT_APP_BASE_URL_QAS) {
// database: user test
 apiDomain = process.env.REACT_APP_API_BASE_URL_QAS;
 

 //PRD API
 }else if (hostname === process.env.REACT_APP_BASE_URL_PRD) {
 // database: production
 apiDomain = process.env.REACT_APP_API_BASE_URL_PRD ;
 }

 export const baseURLs = {
    api: apiDomain ,
   
    // app: domainApp
 }
 